import logger from '@/logger/logger'
import makePrefillObject from './makePrefillObject'
import { IConstructDataObject } from '../FormBuilder'

const callApi = async (
  apiPath: string,
  constructDataObject: IConstructDataObject,
  hasApiError: (data) => void
): Promise<Record<string, unknown>> => {
  try {
    const apiResponse = await fetch(apiPath)
    const apiData = (await apiResponse.json()) as Record<string, unknown>

    if (apiResponse.status < 400) {
      const prefillObject = makePrefillObject(apiData, constructDataObject)

      return prefillObject
    }

    hasApiError(true)
  } catch (e) {
    logger.error(e)
    hasApiError(true)
  }
}

export default callApi
